import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7OPCVMIssuerTSEdit } from "./edit";
import { A7OPCVMIssuerTSTable } from "./table";

export default function A7OPCVMIssuerTS() {
  useEffect(() => {
    setDocumentTitle("Quantilia | OPCVM Émetteurs Séries Temporelles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7OPCVMIssuerTSEdit />} />
      <Route index element={<A7OPCVMIssuerTSTable />} />
    </Routes>
  );
}
